import { type PaymentMethod } from '@/fund/types';

export const ONRAMP_PAYMENT_METHODS: PaymentMethod[] = [
  {
    id: 'CRYPTO_ACCOUNT',
    name: 'Coinbase',
    description: 'Buy with your Coinbase account',
    icon: 'coinbasePay',
  },
  {
    id: 'APPLE_PAY',
    name: 'Apple Pay',
    description: 'Up to $500/week',
    icon: 'applePay',
  },
  {
    id: 'CARD',
    name: 'Debit Card',
    description: 'Up to $500/week',
    icon: 'creditCard',
  },
];
